export default __webpack_public_path__ + "static/media/happy-couple.3e700f00.png";